import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';

export function addReportSuccess() {
  return { type: types.ADD_REPORT_SUCCESS };
}

export function addReport(modelId, modelType) {
  const item = {};
  item.model_id = modelId;
  item.model_type = modelType;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/report`, {
      method: 'POST',
      body: JSON.stringify(item),
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      response.json().then(() => {
        dispatch(addReportSuccess());
      });
    }).catch((error) => {
      throw (error);
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/reportActions.js